import { css } from '@/styled-system/css';

export const propertyCardSaveAreaStyles = css.raw({
  /* Multiple buttons are discouraged but we"ll still accommodate them */
  alignItems: 'start',
  display: 'grid',
  gridAutoFlow: 'column',
  // CDS-1394: Adding negative margins to allow increased button hit area
  // without causing a breaking change to PhotoHeader styles.
  marginTop: `calc(-1 * {spacing.tighter})`,
  marginRight: `calc(-1 * {spacing.tighter})`,
});
